'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertWarning = function AlertWarning(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
AlertWarning = (0, _pure2.default)(AlertWarning);
AlertWarning.displayName = 'AlertWarning';
AlertWarning.muiName = 'SvgIcon';

exports.default = AlertWarning;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/alert/warning.js
// module id = 841
// module chunks = 0